import './marvellous/style';
import FormStructure from './marvellous/form_structure';

export default FormStructure;